// Template Generated by DataExtraction.py at 1716507313

import EnglishReg2 from "../../Forms/KYC2/English_Reg-2.png";
import EnglishReg2Labels from "../../Labels/KYC2/English_Reg-2.json";
import FrenchReg2 from "../../Forms/KYC2/French_Reg-2.png";
import FrenchReg2Labels from "../../Labels/KYC2/French_Reg-2.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel,
    signatureTab,
    formatDayFromDate,
    formatMonthFromDate,
    formatYearFromDate,
    drawText as drawTextAtPos,
} from "../../PDFGenerationUtils";
import { POSSIBLE_SIGNERS } from "../../../Utils/PlanUtils";

import moment from "moment/moment";
import {
    calculateAgeOfYoungestBeneficiary,
    calculateTimeHorizon,
} from "../../../Utils/KYCUtils";
import { t } from "i18next";
import { displayCurrency } from "../../../Utils/FormattingUtils";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? FrenchReg2Labels : EnglishReg2Labels;
    const formImage = isFrench ? FrenchReg2 : EnglishReg2;

    function fillCheckbox(value, label) {
        drawTextOnLabel(doc, value ? t("Yes") : t("No"), label, labels);
    }

    function drawText(value, label, colorOverride = null, bold = false) {
        drawTextOnLabel(doc, value, label, labels, colorOverride, bold);
    }

    // add image
    doc.addImage(
        formImage,
        standardFormFormat,
        labels["image"]["x"],
        labels["image"]["y"],
        labels["image"]["width"],
        labels["image"]["height"],
        null,
        standardFormCompression,
    );

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
     */

    const subscriber = data.subscriber;
    const jointSubscriber = data.jointSubscriber;
    const common = data.common;
    const kyc = data.knowYourClient;
    const plan = data.plan;

    // TODO: check afterwards if these label mappings are correct
    if (kyc.timeHorizon !== undefined)
        drawText(kyc.timeHorizon || "", "timeHorizon");
    if (kyc.objective !== undefined) drawText(kyc.objective || "", "objective");
    if (kyc.leveraging !== undefined)
        fillCheckbox(kyc.leveraging, "leveraging");
    if (kyc.anticipateKeepContributions !== undefined)
        fillCheckbox(kyc.anticipateKeepContributions, "anticipateKeepContributions");
    if (kyc.anticipateAbleToKeepContributions !== undefined)
        fillCheckbox(
            kyc.anticipateAbleToKeepContributions,
            "anticipateAbleToKeepContributions",
        );

    if (kyc.d1Name !== undefined) drawText(kyc.d1Name || "", "d1Name");
    if (kyc.d1Birthdate !== undefined)
        drawText(kyc.d1Birthdate || "", "d1Birthdate");
    if (kyc.d1Edu !== undefined) drawText(kyc.d1Edu || "", "d1Edu");

    if (kyc.d2Name !== undefined) drawText(kyc.d2Name || "", "d2Name");
    if (kyc.d2Birthdate !== undefined)
        drawText(kyc.d2Birthdate || "", "d2Birthdate");
    if (kyc.d2Edu !== undefined) drawText(kyc.d2Edu || "", "d2Edu");

    if (kyc.d3Name !== undefined) drawText(kyc.d3Name || "", "d3Name");
    if (kyc.d3Birthdate !== undefined)
        drawText(kyc.d3Birthdate || "", "d3Birthdate");
    if (kyc.d3Edu !== undefined) drawText(kyc.d3Edu || "", "d3Edu");

    if (kyc.d4Name !== undefined) drawText(kyc.d4Name || "", "d4Name");
    if (kyc.d4Birthdate !== undefined)
        drawText(kyc.d4Birthdate || "", "d4Birthdate");
    if (kyc.d4Edu !== undefined) drawText(kyc.d4Edu || "", "d4Edu");

    if (kyc.ageOfYoungestBene !== undefined)
        drawText(kyc.ageOfYoungestBene?.toString() || "", "ageOfYoungestBene");
    const application = data.application;

    const subscriber2Include = common.subscriber2Include;

    const d1 = data.dependant;
    const d2 = data.dependant2;
    const d3 = data.dependant3;
    const d4 = data.dependant4;

    const beneficiary = data.beneficiary;

    const dateFormat = "MM/DD/yyyy";

    const now = moment().format("yyyy-MM-DD");

    drawText(now, "drDate");
    drawText(now, "s1Date");
    if (subscriber2Include) {
        drawText(now, "s2Date");
    }

    if (kyc.numberOfDependants >= 1) {
        // d1
        drawText(d1.yearsOfEducationalSupport, "d1Edu");
        let d1Name = d1.name;
        let d1Birthdate = moment(d1.birthdate).format(dateFormat);

        if (kyc.beneficiaryIsADependant) {
            d1Name =
                beneficiary.firstName +
                (beneficiary.lastName ? " " + beneficiary.lastName : "");
            d1Birthdate = moment(beneficiary.birthdate).format(dateFormat);
        }

        drawText(d1Name, "d1Name");
        drawText(d1Birthdate, "d1Birthdate");
    }

    if (kyc.numberOfDependants >= 2) {
        // d2
        drawText(moment(d2.birthdate).format(dateFormat), "d2Birthdate");
        drawText(d2.yearsOfEducationalSupport, "d2Edu");
        drawText(d2.name, "d2Name");
    }

    if (kyc.numberOfDependants >= 3) {
        // d3
        drawText(moment(d3.birthdate).format(dateFormat), "d3Birthdate");
        drawText(d3.yearsOfEducationalSupport, "d3Edu");
        drawText(d3.name, "d3Name");
    }

    if (kyc.numberOfDependants >= 4) {
        // d4
        drawText(moment(d4.birthdate).format(dateFormat), "d4Birthdate");
        drawText(d4.yearsOfEducationalSupport, "d4Edu");
        drawText(d4.name, "d4Name");
    }

    drawText(
        `${calculateAgeOfYoungestBeneficiary(beneficiary, kyc)}`,
        "ageOfYoungestBene",
    );
    drawText(calculateTimeHorizon(beneficiary, kyc), "timeHorizon");

    drawText(kyc.objective, "objective");
    drawText(
        common.borrowingToInvest ? t("Yes") : t("No"),
        "leveraging",
        common.borrowingToInvest ? { r: 255, g: 0, b: 0, a: 1 } : null,
    );
    drawText(
        kyc.anticipateKeepContributions ? t("Yes") : t("No"),
        "anticipateKeepContributions",
    );
    drawText(kyc.existingSubscriber ? t("Yes") : t("No"), "existingSubscriber");

    // TODO: Verify property names for these fields
    drawText(
        kyc.anticipateAbleToKeepContributions ? t("Yes") : t("No"),
        "anticipateAbleToKeepContributions",
    );
    drawText(kyc.pepYN ? t("Yes") : t("No"), "PEPOrHIO");
};

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? FrenchReg2Labels : EnglishReg2Labels;
    const DRRecipientId = POSSIBLE_SIGNERS["Dealing Representative"];
    const subscriberRecipientId = POSSIBLE_SIGNERS["Subscriber"];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS["Joint Subscriber"];
    let signers = [];

    const subscriber2Include = state.common.subscriber2Include;

    // s1Signature
    signers.push({
        [subscriberRecipientId]: [
            signatureTab(
                subscriberRecipientId,
                documentId,
                pageNumber,
                signatureLabel("s1Signature", labels),
            ),
        ],
    });

    // drSignature
    signers.push({
        [DRRecipientId]: [
            signatureTab(
                DRRecipientId,
                documentId,
                pageNumber,
                signatureLabel("drSignature", labels),
            ),
        ],
    });

    if (subscriber2Include) {
        // s2Signature
        signers.push({
            [jointSubscriberRecipientId]: [
                signatureTab(
                    jointSubscriberRecipientId,
                    documentId,
                    pageNumber,
                    signatureLabel("s2Signature", labels),
                ),
            ],
        });
    }

    return signers;
};

export default {
    generate,
    signatureDefinitions,
};
